import { ICheckBoxValidatorProcessor } from './ICheckBoxValidatorProcessor'
import { BettingInformation } from '../Model/BettingInformation'

export abstract class ForwardingCheckBoxValidatorProcessor implements ICheckBoxValidatorProcessor {
  constructor(protected next: ICheckBoxValidatorProcessor) {}
  abstract validate(count: number, bettingContext: BettingInformation): boolean
}
